module.exports = __webpack_public_path__ + "static/media/test15_3.19199f23.png";